<template>
  <div v-if="check">
    <el-row :gutter="24">
      <el-col :span="5">
        <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" style="margin-top:50px">
          <el-form-item label="平台" prop="platform">
            <el-input v-model="ruleForm.platform" style="width:220px"></el-input>
          </el-form-item>
          <el-form-item label="帳號" prop="user">
            <el-input v-model="ruleForm.user" style="width:220px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm()">提交</el-button>
          </el-form-item>
        </el-form>
        <div>
          <a :href="url2" v-if="url2 != ''" target="_blank" style="font-size:22px; margin:50px">抽獎連結</a>
        </div>
      </el-col>
      <el-col :span="5">
        <a style="font-size:22px">測試帳號</a>
        <a style="font-size:22px">點擊表格輸入內容</a>
        <el-table :data="tableData" style="width: 100%" @row-click="rowclick">
          <el-table-column prop="platform" label="平台" width="180">
          </el-table-column>
          <el-table-column prop="user" label="帳號" width="180">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="9">
        <el-table :data="entryData" style="width: 100%" @row-click="rowclick">
          <el-table-column prop="PEid" label="活動ID" width="180">
          </el-table-column>
          <el-table-column prop="Name" label="平台" width="180">
          </el-table-column>
          <el-table-column prop="Eid" label="模板ID" width="180">
          </el-table-column>
          <el-table-column prop="Url" label="連結" width="180">
            <template slot-scope="row">
              <a :href="row.row.Url" target="_blank" style="font-size:22px; margin:50px">連結</a>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import md5 from "js-md5";

export default {
  data() {
    return {
      check: true,
      ruleForm: {
        user: '',
        platform: ''
      },
      url: '',
      url2: '',
      status: '',
      entryData: [],
      tableData: [
        {
          platform: '1688',
          user: '0917067496'
        }
      ],
      userInformationData: {
        user: "",
        token: "",
        platform: ""
      },
    };
  },
  mounted() {
    this.entryTest(this.$route.query.user, this.$route.query.token, this.$route.query.p)
    this.getEvents()
  },
  methods: {
    entryTest(user, token, platform) {
      this.userInformationData.user = user
      this.userInformationData.token = token
      this.userInformationData.platform = platform
    },
    async getEvents() {
      this.rolling = true;
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform
      }
      await fetch('/api/getEntryEvents',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == "200") {
            this.entryData = res.data
            let eventName
            this.entryData.forEach(element => {
              switch (element.Eid) {
                case "1":
                  eventName = "luckyDraw"
                  break;
                case "2":
                  eventName = "rabbit"
                  break;
                case "3":
                  eventName = "hongbao"
                  break;
              }
              element.Url = eventName+"?user=" + postData.User + "&p=" + postData.Platform + "&token=" + postData.Token + "&peid=" + element.PEid
            });
          } else {
            this.$message.error(this.$t('turn.' + res.data));
            this.rolling = false;
          }
        })
    },
    rowclick(row) {
      this.ruleForm.platform = row.platform
      this.ruleForm.user = row.user
    },
    submitForm() {
      const nowtime = this.Date()
      let s = this.ruleForm.user + this.ruleForm.platform + nowtime + '07098deee6900ecb19a43b368a06c9ff'
      let token = md5(s)
      this.url2 = "fifa" + this.ruleForm.platform + "?user=" + this.ruleForm.user + "&p=" + this.ruleForm.platform + "&token=" + token
    },
    Date() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes(),
        seconds: nowDate.getSeconds(),
      };

      const newmonth = date.month >= 10 ? date.month : "0" + date.month;
      const newday = date.date >= 10 ? date.date : "0" + date.date;
      return date.year + "-" + newmonth + "-" + newday;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/entry2.vue